<template>
  <Loading v-if="!fullyLoaded" />
  <ChemicalCostForm
    v-else
    :chemicals="chemicals"
    :resource="resource"
    :submit="submit"
    :destroy="destroy"
    :cancel="cancel"
  />
</template>

<script>
import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/chemical_costs_service';
import ChemicalService from '@/services/resources/chemicals_service';

export default {
  mixins: [EditView],
  components: {
    ChemicalCostForm: () => import('@/components/forms/ChemicalCostForm.vue'),
  },
  data() {
    return {
      resourceParams: {
        include: 'site,chemical',
      },
      urlFragment: 'chemicals',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicals: {
      get() {
        return ChemicalService.index({
          filter: { site: this.$route.params.site_id },
        }).then((chemicals) => {
          return chemicals.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
